import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { maintenanceFeatureKey, maintenanceReducer } from './state/maintenance.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MaintenanceEffects } from './state/maintenance.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(maintenanceFeatureKey,maintenanceReducer), 
    EffectsModule.forFeature([MaintenanceEffects])
  ]
})
export class MaintenanceModule { }
